export const CAMPAIGNS_ASSOCIATIONS_FAS_NAMESPACE = 'campaignsAssociations';